import React, { useState, useEffect, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive'
import { Request, makeFormData, eventExecution, pushStateHistoryModal, errorCatch } from 'fennec-ui';
import { IfElse } from '../Rule';
import useStyles from '../Styles';

import { Spin, Button, Modal, message } from 'antd';
import {
    Popup,
    SpinLoading
} from 'antd-mobile';
import RenderToLayer from '../RenderToLayer'


function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}
const onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
        return;
    }
    const pNode = closest(e.target, '.am-modal-content');
    if (!pNode) {
        e.preventDefault();
    }
}

export const FooterButton = ({ key, name, callback, options, isDesktopOrLaptop }) => {
    if (isDesktopOrLaptop) {
        return (<Button key={key} onClick={callback} {...options}>{name}</Button>);
    } else {
        const btn = { text: name, onPress: callback, options };
        return (btn);
    }
}
export function Dialog(props) {
    const classes = useStyles()
    const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 })
    // const isPortrait = useMediaQuery({ orientation: 'portrait' })

    // Props 
    const {
        callback,
        excludeKeyPressed,
        hideMenu,
        isFormData,
        modify,

        // footer, - функция должна возвращать массив объектов для FooterButton
        // trigger,
        content,

        visible,
        titles,
        object,
        okText,
        dismissText,
        stack,
    } = props;

    // Helpers

    // Internal States
    const [loading, setLoading] = useState(false);
    const [opened, setOpened] = useState(false);

    useEffect(()=>{
        if (visible) {
                pushStateHistoryModal(setOpened, getStack);
                setOpened(true);
        } 
    }, [visible])

    // ---------------------------------
    // const [form] = Form.useForm();
    // const closePopup = useCallback(() => {
    //     // form.resetFields();
    //     close();
    // }, [form]);
    // const ContentForm = props.form;
    // ---------------------------------
    // const stack = [];
    const getStack = useCallback(() => {
        return stack;
    }, [stack]);
    // ---------------------------------
    var available = true;
    useEffect(
        () => {
            available = true;
            return () => {
                available = false;
            };
        },
        [ /* TODO: memoization parameters here */]
    );
    // ---------------------------------
    const unlock = React.useCallback(() => {
        setLoading(false);
    }, []);
    const close = React.useCallback(() => {
        setLoading(false);
        if (props.onClose) {
            props.onClose();
        }
        window.history.back();
    }, [props.onClose]);
    // ---------------------------------
    const click = React.useCallback((e) => {
        if (excludeKeyPressed && excludeKeyPressed(e)) {
            return;
        }
        if (content) {
            if (available == true) {
                pushStateHistoryModal(setOpened, getStack);
                setOpened(true);
            };
        } else {
            action({});
        }
        if (hideMenu) {
            hideMenu();
        }
    }, [excludeKeyPressed, hideMenu])
    const action = React.useCallback((_values) => {
        let values = eventExecution(modify, _values, {});
        values = IfElse(isFormData, makeFormData(values), values);
        setLoading(true);
        Request(values,
            IfElse(
                !!props.action,
                props,
                {
                    action: {
                        method: (!isFormData) ? "POST" : "POSTFormData",
                        path: `/api/` + props.document,
                        onClose: ({ close }) => close,
                        onDispatch: () => callback,
                        onError: (err, { unlock }) => {
                            unlock();
                            // message.error(err);
                            errorCatch(err);
                        },
                    }
                }
            ),
            {
                auth: props.auth,
                collection: props.collection || [],
                setCollection: props.setCollection || (() => { }),
                onData: (values) => values.data,
                unlock,
                close,
            }
        );
    }, [modify, isFormData, callback, props.action, props.document, props.collection, props.setCollection, props.auth]);
    // ---------------------------------
    const FooterDismissFunction = () => {
        return close
    }
    const FooterOkFunction = () => {
        return () => action(object)
    }
    const FooterDismissButtons = () => {
        return [
            FooterButton({
                key: "dismiss",
                name: dismissText || 'Закрыть',
                callback: FooterDismissFunction(),
                options: {
                    type: "ghost"
                },
                isDesktopOrLaptop
            })
        ]
    }
    const FooterOkButtons = () => {
        return [
            FooterButton({
                key: "ok",
                name: okText || 'Отправить',
                callback: FooterOkFunction(),
                options: {
                    type: "primary"
                },
                isDesktopOrLaptop
            })
        ]
    }
    const FooterExtendedButtons = (parameters) => {
        // функция должна возвращать массив объектов для FooterButton
        if (props.footerExtendedButtons) {
            let btns = props.footerExtendedButtons(parameters);
            if (btns) {
                return btns.map(e => FooterButton({ isDesktopOrLaptop, ...e }))
            }
        }
        return []
    }
    const footer = React.useCallback(() => {
        let ctx = {
            DismissFunction: FooterDismissFunction(),
            OkFunction: FooterOkFunction(),
            object,
            unlock,
            close,
            loading
        };
        if (props.footer) {
            let btns = props.footer(ctx);
            if (btns) {
                let a = btns.map(e => FooterButton({ isDesktopOrLaptop, ...e }))
                return a
            }
        }
        if (loading) {
            return [
                ...FooterExtendedButtons(ctx),
                ...FooterDismissButtons(),
            ]
        }
        return [
            ...FooterExtendedButtons(ctx),
            ...FooterDismissButtons(),
            ...FooterOkButtons()
        ]
    }, [props.footer, isDesktopOrLaptop, object, unlock, close, loading]);
    const trigger = React.useCallback(() => {
        return (props.trigger) ? props.trigger(click) : <></>;
    }, [props.trigger]);
    const _content = React.useCallback(() => {
        let ctx = {
            DismissFunction: FooterDismissFunction(),
            OkFunction: FooterOkFunction(),
            object,
            unlock,
            close,
            loading
        };
        if (isDesktopOrLaptop) {
            const width = (props.modal) ? props.modal.width : undefined;
            const title = (props.modal && props.modal.title) ? props.modal.title : props.title;
            return (<>
                <Modal
                    afterClose={props.afterClose}
                    width={width}
                    className={classes.modal}
                    title={title}
                    open={opened}
                    closable={true}
                    destroyOnClose={true}
                    onCancel={close}
                    footer={footer()}
                    keyboard={false}
                    bodyStyle={(props.modal && props.modal.bodyStyle) ? props.modal.bodyStyle : {}}
                    {...props.modal}
                >
                    <div style={{ width: "100%", height: "100%", resize: "none" }}>
                        <Spin spinning={loading}>
                            {content(ctx)}
                        </Spin>
                    </div>
                </Modal>
                {trigger && trigger()}
            </>)
        } else {
            return (<>
                <RenderToLayer>
                    <Popup
                        visible={opened}
                        onClose={close}
                        showCloseButton
                        bodyStyle={{ height: '100%' }}
                        destroyOnClose={true}
                    >
                        <div style={{ height: '100%', display: "flex", flexDirection: "column" }}>
                            <div style={{ flex: "0" }}>
                                {(titles && titles.header) ?
                                    <div style={{ display: "flex", justifyContent: "center", padding: "5px 30px 5px 15px", fontSize: "16px" }}>
                                        {titles.header}
                                    </div> : undefined
                                }
                            </div>
                            <div style={{ overflowY: 'scroll', flex: "1" }}>
                                <div style={{ textAlign: "center", fontWeight: "600", fontSize: "14px", minHeight: (!(titles && titles.header)) ? "47px" : "0px" }}>{(titles && titles.subheader) ? titles.subheader : ""}</div>
                                {!loading && <div style={{ overflowY: "scroll", padding: (footer().length) ? "0px 0px 0px 0px" : "0px 0px 15px 0px" }}>
                                    {content(ctx)}
                                </div>}
                                {loading && <div className="loading">
                                    <div className="align" style={{ textAlign: "center" }}>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <SpinLoading style={{ '--size': '32px' }} />
                                        </div>
                                        <span style={{ marginTop: 8 }}>Отправка ...</span>
                                    </div>
                                </div>}
                            </div>
                            <div style={{ flex: "0" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", padding: "10px" }}>
                                    {footer()?.map((e, idx) => <Button key={idx} style={{ flex: "auto" }} type="ghost" {...e.options} onClick={e.onPress}>{e.text}</Button>)}
                                </div>
                            </div>
                        </div>
                    </Popup>
                </RenderToLayer>
                {trigger && trigger()}
            </>);
        }
    }, [props.auth, loading, visible, opened, action, content]);
    return (<>
        {/* <Form form={form}></Form> */}
        {_content()}
    </>);
}
export default React.memo(Dialog)
// Dialog.whyDidYouRender = true
